// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2KVBc","bigColWidth":"Table_bigColWidth__2UM6w","biggerColWidth":"Table_biggerColWidth__oiYLR","row":"Table_row__2wjih","col":"Table_col__eXlbl"};